controllers.controller('HostedPagePopupController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$ionicHistory', '$q', 'LocaleService', 'config',
    'Validator', 'Storage', 'constants', 'UserService', 'API', 'Utils', 'ErrorService', '$interval', '$cookies',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $ionicHistory, $q, LocaleService, config, Validator,
              Storage, Const, UserService, API, Utils, ErrorService, $interval, $cookies) {
        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.showAmountSelect = true;
        $scope.depositValue = Storage.get('depositValue');
        $scope.validator = Validator.getPattern;
        $scope.paymentPopup = null;
        $scope.methodName = $state.params.method.name || '';
        $scope.pspCurrencies = $state.params.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };
        $scope.getUrl = function () {
            return doPayment();
        };

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function checkResponse(data) {
            if (data.status !== 1 || (data.RedirectURL && data.RedirectURL.length === 0)) {
                throw new ErrorService({
                    source: 'HostedPagePopupController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function updatePopup(response) {
            return $q(function (resolve, reject) {
                var timer = $interval(isPopupClosed, 100);
                API.subscribe('depositConfirm', clearPayment);
                if (response.RedirectURL && (!response.PostData || !response.PostData.length)) {
                    $scope.paymentPopup.location = response.RedirectURL;
                }
                if(response.RedirectURL && (response.PostData && response.PostData.length) ) {
                    Utils.insertDocumentScripts($scope.paymentPopup.document, response.PostData);
                    $scope.paymentPopup.document.getElementsByTagName('body')[0].appendChild(Utils.generateForm(response.RedirectURL, response.PostData));
                    $scope.paymentPopup.document.getElementById('form3ds').submit();
                }

                function isPopupClosed() {
                    if ($scope.paymentPopup && $scope.paymentPopup.closed) {
                        $interval.cancel(timer);
                        $scope.paymentPopup = null;
                        $ionicLoading.hide();
                        $scope.paymentMethods.length > 1 ? $state.go('root.app.wallet') : $state.go( 'root.app.assets');
                    }
                }

                function clearPayment(confirmResponse) {
                    API.unsubscribe('depositConfirm');
                    $interval.cancel(timer);
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    try {
                        checkResponse(confirmResponse);
                    } catch (e) {
                        reject(e);
                    }
                    resolve(confirmResponse);
                }
            });
        }

        function doPayment() {
            $ionicLoading.show();
            openPaymentPopup();

            var request = {
                amount: parseInt($scope.amount.value, 10),
                pspCurrency: $scope.amount.pspCurrency || undefined,
                pspName: Const.paymentMethodsBlueprint[$state.params.method.name] || $state.params.method.name,
                remarketing: $cookies.get('remarketing') || ''
            };

            return API.hostedPageDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    if (response.RedirectURL && response.RedirectURL.length > 0) {
                        return updatePopup(response);
                    }
                })
                .then(function (response) {
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $ionicLoading.hide();

                    $cookies.get('remarketing') && $cookies.remove('remarketing');
                    $scope.modal.textTitle = LocaleService.translation.messages.depositSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.actionText = LocaleService.translation.startTrading;

                    $scope.modal.date = Date.now();
                    $scope.modal.transactionId = response.transactionId;
                    $scope.modal.amount = response.amount;
                    $scope.modal.currency = response.currency;
                    $scope.modal.method = $state.params.method.name;

                    $scope.modal.state = true;
                    $scope.modal.back = 'root.app.assets';
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.depositFailed;
                    $scope.paymentPopup && $scope.paymentPopup.close();
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages.depositFailedText;
                    $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }

        function openPaymentPopup() {
            var opts2 = 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=10, height=10, visible=none';
            $scope.paymentPopup = window.open('', '_blank', opts2);
        }

        function clear() {
            API.unsubscribe('depositConfirm');
            $scope.depositValue = null;
            $scope.user = null;
            $scope.paymentPopup = null;
            $ionicHistory.clearHistory();
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if($state.params.method.hasOwnProperty("amountRequired") && !$state.params.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
                doPayment();
            }
        });
        
        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }]);
